module.exports = __webpack_public_path__ + "static/media/30_tn.dcc59223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/30_tn.jpg
// module id = 518
// module chunks = 0